/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Metadata from './Metadata';

/**
 * The Asset model module.
 * @module model/Asset
 * @version 1.0.0
 */
class Asset {
    /**
     * Constructs a new <code>Asset</code>.
     * @alias module:model/Asset
     */
    constructor() { 
        
        Asset.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Asset</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Asset} obj Optional instance to populate.
     * @return {module:model/Asset} The populated <code>Asset</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Asset();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('effectivePermission')) {
                obj['effectivePermission'] = ApiClient.convertToType(data['effectivePermission'], 'String');
            }
            if (data.hasOwnProperty('airDate')) {
                obj['airDate'] = ApiClient.convertToType(data['airDate'], 'String');
            }
            if (data.hasOwnProperty('anamorphic')) {
                obj['anamorphic'] = ApiClient.convertToType(data['anamorphic'], 'Boolean');
            }
            if (data.hasOwnProperty('parentID')) {
                obj['parentID'] = ApiClient.convertToType(data['parentID'], 'String');
            }
            if (data.hasOwnProperty('folder')) {
                obj['folder'] = ApiClient.convertToType(data['folder'], 'Boolean');
            }
            if (data.hasOwnProperty('firstChild')) {
                obj['firstChild'] = ApiClient.convertToType(data['firstChild'], 'String');
            }
            if (data.hasOwnProperty('metadata')) {
                obj['metadata'] = ApiClient.convertToType(data['metadata'], [Metadata]);
            }
            if (data.hasOwnProperty('assetStatus')) {
                obj['assetStatus'] = ApiClient.convertToType(data['assetStatus'], 'String');
            }
            if (data.hasOwnProperty('codec')) {
                obj['codec'] = ApiClient.convertToType(data['codec'], 'String');
            }
            if (data.hasOwnProperty('created')) {
                obj['created'] = ApiClient.convertToType(data['created'], 'Date');
            }
            if (data.hasOwnProperty('externalRights')) {
                obj['externalRights'] = ApiClient.convertToType(data['externalRights'], 'Boolean');
            }
            if (data.hasOwnProperty('height')) {
                obj['height'] = ApiClient.convertToType(data['height'], 'Number');
            }
            if (data.hasOwnProperty('hidden')) {
                obj['hidden'] = ApiClient.convertToType(data['hidden'], 'Boolean');
            }
            if (data.hasOwnProperty('highres')) {
                obj['highres'] = ApiClient.convertToType(data['highres'], 'String');
            }
            if (data.hasOwnProperty('lastModified')) {
                obj['lastModified'] = ApiClient.convertToType(data['lastModified'], 'Date');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('offset')) {
                obj['offset'] = ApiClient.convertToType(data['offset'], 'String');
            }
            if (data.hasOwnProperty('onDisk')) {
                obj['onDisk'] = ApiClient.convertToType(data['onDisk'], 'Boolean');
            }
            if (data.hasOwnProperty('onTape')) {
                obj['onTape'] = ApiClient.convertToType(data['onTape'], 'Boolean');
            }
            if (data.hasOwnProperty('progress')) {
                obj['progress'] = ApiClient.convertToType(data['progress'], 'String');
            }
            if (data.hasOwnProperty('proxy')) {
                obj['proxy'] = ApiClient.convertToType(data['proxy'], 'String');
            }
            if (data.hasOwnProperty('restricted')) {
                obj['restricted'] = ApiClient.convertToType(data['restricted'], 'Boolean');
            }
            if (data.hasOwnProperty('tapeID')) {
                obj['tapeID'] = ApiClient.convertToType(data['tapeID'], 'String');
            }
            if (data.hasOwnProperty('thumbnail')) {
                obj['thumbnail'] = ApiClient.convertToType(data['thumbnail'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('width')) {
                obj['width'] = ApiClient.convertToType(data['width'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Asset</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Asset</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['effectivePermission'] && !(typeof data['effectivePermission'] === 'string' || data['effectivePermission'] instanceof String)) {
            throw new Error("Expected the field `effectivePermission` to be a primitive type in the JSON string but got " + data['effectivePermission']);
        }
        // ensure the json data is a string
        if (data['airDate'] && !(typeof data['airDate'] === 'string' || data['airDate'] instanceof String)) {
            throw new Error("Expected the field `airDate` to be a primitive type in the JSON string but got " + data['airDate']);
        }
        // ensure the json data is a string
        if (data['parentID'] && !(typeof data['parentID'] === 'string' || data['parentID'] instanceof String)) {
            throw new Error("Expected the field `parentID` to be a primitive type in the JSON string but got " + data['parentID']);
        }
        // ensure the json data is a string
        if (data['firstChild'] && !(typeof data['firstChild'] === 'string' || data['firstChild'] instanceof String)) {
            throw new Error("Expected the field `firstChild` to be a primitive type in the JSON string but got " + data['firstChild']);
        }
        if (data['metadata']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['metadata'])) {
                throw new Error("Expected the field `metadata` to be an array in the JSON data but got " + data['metadata']);
            }
            // validate the optional field `metadata` (array)
            for (const item of data['metadata']) {
                Metadata.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['assetStatus'] && !(typeof data['assetStatus'] === 'string' || data['assetStatus'] instanceof String)) {
            throw new Error("Expected the field `assetStatus` to be a primitive type in the JSON string but got " + data['assetStatus']);
        }
        // ensure the json data is a string
        if (data['codec'] && !(typeof data['codec'] === 'string' || data['codec'] instanceof String)) {
            throw new Error("Expected the field `codec` to be a primitive type in the JSON string but got " + data['codec']);
        }
        // ensure the json data is a string
        if (data['highres'] && !(typeof data['highres'] === 'string' || data['highres'] instanceof String)) {
            throw new Error("Expected the field `highres` to be a primitive type in the JSON string but got " + data['highres']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['offset'] && !(typeof data['offset'] === 'string' || data['offset'] instanceof String)) {
            throw new Error("Expected the field `offset` to be a primitive type in the JSON string but got " + data['offset']);
        }
        // ensure the json data is a string
        if (data['progress'] && !(typeof data['progress'] === 'string' || data['progress'] instanceof String)) {
            throw new Error("Expected the field `progress` to be a primitive type in the JSON string but got " + data['progress']);
        }
        // ensure the json data is a string
        if (data['proxy'] && !(typeof data['proxy'] === 'string' || data['proxy'] instanceof String)) {
            throw new Error("Expected the field `proxy` to be a primitive type in the JSON string but got " + data['proxy']);
        }
        // ensure the json data is a string
        if (data['tapeID'] && !(typeof data['tapeID'] === 'string' || data['tapeID'] instanceof String)) {
            throw new Error("Expected the field `tapeID` to be a primitive type in the JSON string but got " + data['tapeID']);
        }
        // ensure the json data is a string
        if (data['thumbnail'] && !(typeof data['thumbnail'] === 'string' || data['thumbnail'] instanceof String)) {
            throw new Error("Expected the field `thumbnail` to be a primitive type in the JSON string but got " + data['thumbnail']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {String} id
 */
Asset.prototype['id'] = undefined;

/**
 * What the calling user may do with this asset. Computed per request from the permission grants on the asset and its ancestors; never stored and ignored on write.
 * @member {module:model/Asset.EffectivePermissionEnum} effectivePermission
 */
Asset.prototype['effectivePermission'] = undefined;

/**
 * @member {String} airDate
 */
Asset.prototype['airDate'] = undefined;

/**
 * @member {Boolean} anamorphic
 */
Asset.prototype['anamorphic'] = undefined;

/**
 * @member {String} parentID
 */
Asset.prototype['parentID'] = undefined;

/**
 * @member {Boolean} folder
 */
Asset.prototype['folder'] = undefined;

/**
 * @member {String} firstChild
 */
Asset.prototype['firstChild'] = undefined;

/**
 * @member {Array.<module:model/Metadata>} metadata
 */
Asset.prototype['metadata'] = undefined;

/**
 * @member {module:model/Asset.AssetStatusEnum} assetStatus
 */
Asset.prototype['assetStatus'] = undefined;

/**
 * @member {String} codec
 */
Asset.prototype['codec'] = undefined;

/**
 * @member {Date} created
 */
Asset.prototype['created'] = undefined;

/**
 * @member {Boolean} externalRights
 */
Asset.prototype['externalRights'] = undefined;

/**
 * @member {Number} height
 */
Asset.prototype['height'] = undefined;

/**
 * @member {Boolean} hidden
 */
Asset.prototype['hidden'] = undefined;

/**
 * @member {String} highres
 */
Asset.prototype['highres'] = undefined;

/**
 * @member {Date} lastModified
 */
Asset.prototype['lastModified'] = undefined;

/**
 * @member {String} name
 */
Asset.prototype['name'] = undefined;

/**
 * @member {String} offset
 */
Asset.prototype['offset'] = undefined;

/**
 * @member {Boolean} onDisk
 */
Asset.prototype['onDisk'] = undefined;

/**
 * @member {Boolean} onTape
 */
Asset.prototype['onTape'] = undefined;

/**
 * @member {String} progress
 */
Asset.prototype['progress'] = undefined;

/**
 * @member {String} proxy
 */
Asset.prototype['proxy'] = undefined;

/**
 * @member {Boolean} restricted
 */
Asset.prototype['restricted'] = undefined;

/**
 * @member {String} tapeID
 */
Asset.prototype['tapeID'] = undefined;

/**
 * @member {String} thumbnail
 */
Asset.prototype['thumbnail'] = undefined;

/**
 * @member {String} title
 */
Asset.prototype['title'] = undefined;

/**
 * @member {Number} width
 */
Asset.prototype['width'] = undefined;





/**
 * Allowed values for the <code>effectivePermission</code> property.
 * @enum {String}
 * @readonly
 */
Asset['EffectivePermissionEnum'] = {

    /**
     * value: "NONE"
     * @const
     */
    "NONE": "NONE",

    /**
     * value: "VIEW"
     * @const
     */
    "VIEW": "VIEW",

    /**
     * value: "EDIT"
     * @const
     */
    "EDIT": "EDIT",

    /**
     * value: "MANAGE"
     * @const
     */
    "MANAGE": "MANAGE"
};


/**
 * Allowed values for the <code>assetStatus</code> property.
 * @enum {String}
 * @readonly
 */
Asset['AssetStatusEnum'] = {

    /**
     * value: "UPLOADING"
     * @const
     */
    "UPLOADING": "UPLOADING",

    /**
     * value: "PENDING"
     * @const
     */
    "PENDING": "PENDING",

    /**
     * value: "TRANSCODING"
     * @const
     */
    "TRANSCODING": "TRANSCODING",

    /**
     * value: "COMPLETED"
     * @const
     */
    "COMPLETED": "COMPLETED",

    /**
     * value: "FAILED"
     * @const
     */
    "FAILED": "FAILED",

    /**
     * value: "MOVING"
     * @const
     */
    "MOVING": "MOVING",

    /**
     * value: "RESTORING"
     * @const
     */
    "RESTORING": "RESTORING"
};



export default Asset;

